import React, {Component} from 'react'
import PropTypes from 'prop-types'

import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {DialogActions, DialogContent, DialogTitle, Slide, withStyles, Typography} from '@material-ui/core'

import LoginModalStyles, {LoginStyledDialog} from './LoginModal.styles'
import FormTextInput from '../FormElement/FormElement'
import {authActions} from '../../core/actions'
import {SubmitButton} from '../components'
import { validations } from '../../util/validations';

const Transition = function (props) {
    return <Slide direction="up" {...props} />
}

const mapStateToProps = state => ({
    isLoggingIn: state.auth.loading,
    error: state.auth.error,
    user: state.auth.user
})

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({...authActions}, dispatch)
})

export class LoginModal extends Component {
    static propTypes = {
        classes: PropTypes.object.isRequired
    }

    state = {
        isOpen: false,
        isDisabled: true
    }

    formFields = [
        {label: 'Email', name: 'username', minLength: 1, maxLength: 100, type: 'email', validations: validations.login.email, required: true},
        {label: 'Password', name: 'password', minLength: 8, maxLength: 128, type: 'password', required: true}
    ]

    toggleOpen = isOpen => () => this.setState({isOpen})

    onValidationChangeDetected = () => this.setState({
        isDisabled: ((this.formFields.username && !this.formFields.username.state.isValid) ||
            (this.formFields.password && !this.formFields.password.state.isValid))
    })

    onLoginClick = () => {
        this.props.loginUser(this.formFields.username.state.value, this.formFields.password.state.value, this.toggleOpen(false))
    }

    render() {
        const {classes: styles, isLoggingIn, error} = this.props

        return (
            <LoginStyledDialog
                open={this.state.isOpen}
                onClose={this.toggleOpen(false)}
                aria-labelledby="form-dialog-title"
                TransitionComponent={Transition}
                keepMounted
                fullWidth
            >
                <DialogTitle className={styles.title} id="form-dialog-title">Login</DialogTitle>

                <DialogContent className={styles.content}>
                    {this.formFields.map((props, index) => <FormTextInput key={index} {...props} innerRef={ref => (this.formFields[props.name] = ref)} onValidationChangeDetected={this.onValidationChangeDetected} />)}
                    {error && <Typography className={styles.errorMessage} variant="body1" color="secondary">{error.type}</Typography>}
                </DialogContent>

                <DialogActions className={styles.actionButtons}>
                    <SubmitButton isDisabled={this.state.isDisabled} isProcessing={isLoggingIn} onClick={this.onLoginClick} loadingText={'Logging in..'}>Login</SubmitButton>
                </DialogActions>
            </LoginStyledDialog>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(LoginModalStyles)(LoginModal))
